<app-page-body *ngIf="!isVisibleAuditPage">
  <!-- header -->
  <app-page-header
    *ngIf="showPageHeader"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form
      [id]="formId"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
    >
      <section>
        <fieldset>
          <legend>
            {{ "common.socialMediaGroupPriceDetail" | translate }}
          </legend>

          <ng-content select="[legend]"> </ng-content>

          <div class="tw-flex-center tw-flex-col">
            <div
              class="tw-flex tw-justify-center flex-column tw-py-[5px] tw-px-[5px]"
            >
              <!-- editable -->
              <div class="editable-table">
                <ng-content select="[BeforeContent]"></ng-content>

                <!-- alert -->
                <div class="tw-mb-5 tw-text-center">
                  <span class="text-danger"> * </span>
                  <span
                    class="tw-font-medium dark:tw-text-gray-300"
                    translate
                    [translateParams]="{
                      currency: 'common.currency' | translate
                    }"
                  >
                    messages.currencyAlert
                  </span>
                </div>

                <!-- mciSmartPercent -->
                <div
                  class="tw-mb-5 tw-text-center tw-text-primary-700 dark:tw-text-primary-300"
                  *ngIf="(groupPrices | json) != ({} | json)"
                >
                  {{ "common.mciSmartPercent" | translate }}
                  <span class="tw-font-bold">
                    %{{ groupPrices?.mciSmartPercent }}
                  </span>
                </div>

                <!-- mtnSmartPercent -->
                <div
                  class="tw-mb-5 tw-text-center tw-text-yellow-500"
                  *ngIf="(groupPrices | json) != ({} | json)"
                >
                  {{ "common.mtnSmartPercent" | translate }}
                  <span class="tw-font-bold">
                    %{{ groupPrices?.mtnSmartPercent }}
                  </span>
                </div>

                <!-- rightelSmartPercent -->
                <div
                  class="tw-mb-5 tw-text-center tw-text-indigo-500"
                  *ngIf="(groupPrices | json) != ({} | json)"
                >
                  {{ "common.rightelSmartPercent" | translate }}
                  <span class="tw-font-bold">
                    %{{ groupPrices?.rightelSmartPercent }}
                  </span>
                </div>

                <!-- cols -->
                <div class="cols">
                  <!-- empty col -->
                  <div
                    class="col__item tw-flex-center tw-font-medium tw-text-[13px]"
                    style="width: 210px"
                  >
                    <!-- {{"common.smsCp"|translate}} -->
                    {{ "messages.socialMediaSizeRangeMessage" | translate }}
                  </div>

                  <ng-container
                    *ngFor="let item of SmsAggregatorValues; let index = index"
                  >
                    <ng-container *ngIf="+item?.value">
                      <div class="col__item">
                        <!-- title -->
                        <div
                          class="col__title dark:tw-text-gray-200"
                          [class]="item?.key"
                          [smsAggregatorBgColor]="item?.key"
                        >
                          {{ "enums.SmsAggregator." + item?.key | translate }}
                          <img
                            class="tw-mx-3 hide-in-sm"
                            [smsAggregatorImage]="item?.key"
                            [smsAggregatorImageWidth]="item?.key"
                          />
                        </div>

                        <!-- inputs -->
                        <div *ngIf="!readOnly" class="col__inputs">
                          <div class="col__input">
                            <input
                              type="number"
                              #smsAggregatorInput
                              min="0"
                              [onlyNumbers]="true"
                              (keydown)="
                                fillColumn(
                                  item.value,
                                  smsAggregatorInput,
                                  $event
                                )
                              "
                              step="50"
                              class="dir-ltr"
                              class="input-group"
                            />

                            <i
                              class="fas fa-arrow-down text-navyBlue"
                              (click)="
                                fillColumn(item.value, smsAggregatorInput)
                              "
                            ></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>

                <!-- rows -->
                <div class="rows">
                  <ng-container
                    *ngFor="let range of sizeRanges; let rangeIndex = index"
                  >
                    <div class="row__flex">
                      <!-- SmsCpValues names -->
                      <div class="row__title tw-px-1 tw-relative">
                        <!-- beginningOfSize -->
                        <span class="tw-mx-[5px]">{{
                          "common.from" | translate
                        }}</span>
                        <input
                          #beginningInput
                          [readOnly]="readOnly"
                          class="dark:tw-bg-dark-500 size-input"
                          [value]="
                            range?.beginningOfSize ||
                            range?.beginningOfSize == 0
                              ? range?.beginningOfSize
                              : ''
                          "
                          (input)="
                            onUpdateSizeRange(
                              beginningInput,
                              endInput,
                              rangeIndex
                            )
                          "
                        />

                        <!-- endOfSize -->
                        <span class="tw-mx-[5px]">{{
                          "common.to" | translate
                        }}</span>
                        <input
                          #endInput
                          [readOnly]="readOnly"
                          class="dark:tw-bg-dark-500 size-input"
                          [value]="
                            range?.endOfSize || range?.endOfSize == 0
                              ? range?.endOfSize
                              : ''
                          "
                          (input)="
                            onUpdateSizeRange(
                              beginningInput,
                              endInput,
                              rangeIndex
                            )
                          "
                        />

                        <!-- infinity btn  -->
                        <div
                          *ngIf="
                            rangeIndex == sizeRanges.length - 1 &&
                            !range?.endOfSize
                          "
                          class="bg-bright-primary tw-cursor-pointer dark:tw-bg-primary-600 tw-text-[#283891] hover:tw-bg-blue-700 tw-flex justify-center tw-px-1 items-center tw-absolute tw-h-[18px] tw-left-[18px] tw-rounded-[5px]"
                          (click)="
                            setInfinite(beginningInput, endInput, rangeIndex)
                          "
                        >
                          ∞
                        </div>

                        <!-- add btn  -->
                        <!-- <i *ngIf="rangeIndex==sizeRanges?.length-1" (click)="onAddSizeRange()"
                          class="tw-absolute lg:tw-right-[-35px] tw-right-[-19px] mdi mdi-24px
                                                        tw-bg-white tw-rounded-full dark:tw-bg-dark-500 mdi-plus-circle text-success tw-mx-1 tw-cursor-pointer"></i> -->

                        <!-- remove btn  -->
                        <i
                          *ngIf="
                            rangeIndex != sizeRanges?.length &&
                            sizeRanges?.length > 1 &&
                            !readOnly
                          "
                          (click)="onRemoveSizeRange(rangeIndex)"
                          class="tw-absolute lg:tw-right-[-35px] tw-right-[-19px] mdi mdi-24px tw-bg-white tw-rounded-full dark:tw-bg-dark-500 mdi-close-circle-outline text-danger tw-mx-1 tw-cursor-pointer"
                        ></i>
                      </div>

                      <!-- input values -->
                      <ng-container *ngFor="let priceItem of range.priceList">
                        <ng-container *ngIf="priceItem.smsAggregator">
                          <div class="row__value">
                            <input
                              #priceInput
                              [readOnly]="readOnly"
                              type="number"
                              class="input-item dir-ltr"
                              min="0"
                              step="1000"
                              (focus)="isEmptyInput($event)"
                              (change)="isEmptyInput($event)"
                              [attr.data-aggregator]="+priceItem.smsAggregator"
                              [attr.data-beginningOfSize]="
                                range?.beginningOfSize
                              "
                              [attr.data-endOfSize]="range?.endOfSize"
                              [value]="priceItem?.price"
                              placeholder="-"
                            />
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div *ngIf="!readOnly" class="tw-mt-[10px]">
                <a
                  class="btn tw-mx-2"
                  class="btn btn-light-success tw-w-[210px]"
                  (click)="onAddSizeRange()"
                >
                  <span>{{ "common.addRow" | translate }}</span>
                  <i class="mdi mdi-plus-circle tw-text-xl"></i>
                </a>
              </div>

              <!-- copy paste -->
              <div
                class="tw-flex tw-justify-between tw-items-center tw-mt-[30px]"
              >
                <div class="tw-flex-center tw-relative">
                  <div class="tw-mx-1 tw-relative">
                    <label
                      class="tw-text-gray-500 tw-absolute tw-left-[43px] tw-top-[-9px] tw-px-[5px] tw-bg-white dark:tw-bg-dark-300 tw-text-center tw-z-10 form-label tw-mb-1 tw-mr-[5px] ltr:tw-ml-[5px]"
                      for="megabyte-input"
                      >{{ "common.megabyte" | translate }}</label
                    >
                    <input
                      type="tell"
                      id="megabyte-input"
                      formControlName="megabyte"
                      [(ngModel)]="megaByteValue"
                      class="tw-border pt-[13px] pb-[4px] tw-text-center tw-border-gray-400 tw-max-w-[140px] form-control input-group"
                      (input)="convertMbToKb()"
                    />
                  </div>

                  <div
                    class="tw-bg-indigo-200 tw-z-10 tw-rounded-md tw-flex-center tw-absolute"
                  >
                    <i
                      class="mdi mdi-28px mdi-swap-horizontal tw-text-indigo-500"
                    ></i>
                  </div>

                  <div class="tw-mx-1 tw-relative">
                    <label
                      class="tw-text-gray-500 tw-absolute tw-left-[43px] tw-top-[-9px] tw-px-[5px] tw-bg-white dark:tw-bg-dark-300 tw-text-center tw-z-10 form-label tw-mb-1 tw-mr-[5px] ltr:tw-ml-[5px]"
                      for="kilobyte-input"
                      >{{ "common.kilobyte" | translate }}</label
                    >
                    <input
                      type="tell"
                      id="kilobyte-input"
                      formControlName="kilobyte"
                      (input)="convertKBtoMb()"
                      class="tw-border pt-[13px] pb-[4px] tw-text-center tw-border-gray-400 tw-max-w-[140px] form-control input-group"
                      [(ngModel)]="kiloByteValue"
                    />
                  </div>
                </div>

                <div>
                  <a
                    *ngIf="!readOnly || userSession?.isSuperAdmin()"
                    class="btn tw-mx-2"
                    [themeColor]="'btn-light-info'"
                    copyToClipboard
                    (click)="copyTableContent()"
                  >
                    <span>{{ "common.copyContent" | translate }}</span>
                    <i class="mdi mdi-content-copy tw-text-xl"></i>
                  </a>

                  <a
                    *ngIf="!readOnly"
                    class="btn tw-mx-2"
                    [themeColor]="'btn-light'"
                    (click)="pasteTableContent()"
                  >
                    <i class="mdi mdi-content-paste tw-text-xl"></i>
                    <span>{{ "common.pasteContent" | translate }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        *ngIf="!readOnly"
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        buttonType="button"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
